<template>
  <div class="container is-fluid py-6">
    <div
      class="box has-background-black-ter ctrn"
      style="max-width: 640px; margin: 0 auto"
    >
      <div class="has-text-centered mb-4">
        <img
          src="/img/modul/Modul-12t.png"
          alt="Logo Modul"
          style="
            max-width: 120px;
            max-height: 120px;
            border-radius: 12px;
            background: #1f2229;
          "
        />
      </div>
      <h2 class="title is-4 has-text-white has-text-centered">
        {{ $t("initial modul setup") }}
      </h2>
      <div v-if="step === 1">
        <h3 class="subtitle is-6 has-text-grey-lighter has-text-centered">
          {{ $t("step 1: company and admin user") }}
        </h3>
        <form @submit.prevent="nextStep">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("company name")
                }}</label>
                <div class="control">
                  <input class="input" v-model="company.name" required />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("admin username")
                }}</label>
                <div class="control">
                  <input class="input" v-model="admin.username" required />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("admin password")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="admin.password"
                    type="password"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("confirm password")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="admin.confirmPassword"
                    type="password"
                    required
                  />
                </div>
                <p
                  v-if="
                    admin.password &&
                    admin.confirmPassword &&
                    admin.password !== admin.confirmPassword
                  "
                  class="help is-danger"
                >
                  {{ $t("passwords do not match") }}
                </p>
              </div>
            </div>
          </div>
          <div class="field is-grouped is-grouped-right mt-5">
            <div class="control">
              <button
                class="button is-primary"
                type="submit"
                :disabled="admin.password !== admin.confirmPassword"
              >
                <span class="icon is-small">
                  <i class="fa fa-arrow-right"></i>
                </span>
                <span>{{ $t("next") }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div v-else-if="step === 2">
        <h3 class="subtitle is-6 has-text-grey-lighter has-text-centered">
          {{ $t("step 2: database connection") }}
        </h3>
        <form @submit.prevent="nextStep">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{ $t("host") }}</label>
                <div class="control">
                  <input class="input" v-model="db.host" required />
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label has-text-white">{{ $t("port") }}</label>
                <div class="control">
                  <input class="input" v-model="db.port" required />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{ $t("database") }}</label>
                <div class="control">
                  <input class="input" v-model="db.database" required />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{ $t("dialect") }}</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="db.dialect" required>
                      <option disabled value="">
                        {{ $t("select a dialect") }}
                      </option>
                      <option value="mysql">MySQL</option>
                      <option disabled value="postgres">PostgreSQL</option>
                      <option disabled value="mssql">MSSQL</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{ $t("username") }}</label>
                <div class="control">
                  <input class="input" v-model="db.username" required />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label has-text-white">{{ $t("password") }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="db.password"
                    type="password"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="control">
            <button
              class="button is-info"
              type="button"
              @click="test_db_connection"
            >
              <span class="icon is-small">
                <i class="fa fa-bolt"></i>
              </span>
              <span>{{ $t("test connection") }}</span>
            </button>
          </div>

          <article class="message is-info mt-3" v-if="db_test_result">
            <div class="message-body">
              <p>{{ db_test_result }}</p>
            </div>
          </article>

          <div class="field is-grouped is-grouped-right mt-5">
            <div class="control">
              <button class="button" type="button" @click="prevStep">
                <span class="icon is-small">
                  <i class="fa fa-arrow-left"></i>
                </span>
                <span>{{ $t("previous") }}</span>
              </button>
            </div>
            <div class="control">
              <button class="button is-primary" type="submit">
                <span class="icon is-small">
                  <i class="fa fa-arrow-right"></i>
                </span>
                <span>{{ $t("next") }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div v-else-if="step === 3">
        <h3 class="subtitle is-6 has-text-grey-lighter has-text-centered">
          {{ $t("step 3: system variables") }}
        </h3>
        <form @submit.prevent="nextStep">
          <div class="columns mb-1">
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("python executable path")
                }}</label>
                <div class="control">
                  <input class="input" v-model="system.pythonPath" required />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field is-grouped">
                <label for="">&nbsp;</label>
                <div class="control">
                  <button
                    class="button is-info"
                    type="button"
                    @click="test_python"
                  >
                    <span class="icon is-small">
                      <i class="fa fa-bolt"></i>
                    </span>
                    <span>{{ $t("test") }}</span>
                  </button>
                </div>
              </div>
              <div class="control">
                <article class="message is-info mt-3" v-if="python_test_result">
                  <div class="message-body">
                    <p>{{ python_test_result }}</p>
                  </div>
                </article>
              </div>
            </div>
          </div>

          <!-- Campos de configuración de empresa (migrados a variables de sistema) -->
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{ $t("currency") }}</label>
                <div class="control">
                  <div class="select">
                    <select v-model="company.currency">
                      <option
                        v-for="(currency, cidx) in currencies"
                        :key="cidx"
                        :value="currency.value"
                      >
                        {{ $t(currency.text) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("date format")
                }}</label>
                <div class="control">
                  <input class="input" v-model="company.date_format" required />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("time format")
                }}</label>
                <div class="control">
                  <input class="input" v-model="company.time_format" required />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("date time format")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="company.date_time_format"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("default language")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="company.default_language"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{ $t("jwt key") }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="company.system_authentication_jwt_key"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("jwt expire time unit")
                }}</label>
                <div class="control">
                  <div class="select">
                    <select
                      v-model="
                        company.system_authentication_jwt_expire_time_unit
                      "
                    >
                      <option value="m">{{ $t("minute") }}</option>
                      <option value="h">{{ $t("hour") }}</option>
                      <option value="d">{{ $t("day") }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label has-text-white">{{
                  $t("jwt expire time quantity")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    v-model="
                      company.system_authentication_jwt_expire_time_quantity
                    "
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="field is-grouped is-grouped-right mt-5">
            <div class="control">
              <button class="button" type="button" @click="prevStep">
                <span class="icon is-small">
                  <i class="fa fa-arrow-left"></i>
                </span>
                <span>{{ $t("previous") }}</span>
              </button>
            </div>
            <div class="control">
              <button class="button is-primary" type="submit">
                <span class="icon is-small">
                  <i class="fa fa-arrow-right"></i>
                </span>
                <span>{{ $t("next") }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div v-else-if="step === 4">
        <h3 class="title is-5 has-text-success has-text-centered">
          {{ $t("ready to initialize") }}
        </h3>
        <p class="has-text-centered has-text-white mb-5">
          {{
            $t(
              "the system will be initialized with the provided data. click the button below to start the initialization process"
            )
          }}
        </p>
        <div class="has-text-centered mb-2">
          <button
            class="button is-success is-medium"
            :class="{ 'is-loading': is_initializing }"
            @click="submitConfig"
            :disabled="is_initializing"
          >
            <span class="icon is-small">
              <i class="fa fa-cog"></i>
            </span>
            <span>{{ $t("initialize system") }}</span>
          </button>
        </div>
        <div class="mt-1" v-if="is_initializing">
          <p class="has-text-centered has-text-white mt-5">
            {{ $t("this process may take a few minutes") }}
          </p>
          <div class="content has-text-centered mt-5">
            <div class="list">
              <p
                class="mb-1"
                :class="{
                  'has-text-white': is_settings_inited,
                }"
              >
                <span class="icon">
                  <i
                    class="fa"
                    :class="{
                      'fa-clock-o': is_settings_inited == false,
                      'fa-check': is_settings_inited == true,
                      'has-text-success': is_settings_inited == true,
                      'fa-spinner fa-spin':
                        init_step == 'settings_file' && !is_settings_inited,
                    }"
                  ></i>
                </span>
                <span>{{ $t("initializing settings file...") }}</span>
              </p>
              <p
                class="mb-1"
                :class="{
                  'has-text-white': is_modul_restarted,
                }"
              >
                <span class="icon">
                  <i
                    class="fa"
                    :class="{
                      'fa-clock-o': is_modul_restarted == false,
                      'fa-check': is_modul_restarted == true,
                      'has-text-success': is_modul_restarted == true,
                      'fa-spinner fa-spin':
                        init_step == 'restart_modul' && !is_modul_restarted,
                    }"
                  ></i>
                </span>
                <span>{{ $t("restarting modul...") }}</span>
              </p>
              <p
                class="mb-1"
                :class="{
                  'has-text-white': is_database_inited,
                }"
              >
                <span class="icon">
                  <i
                    class="fa"
                    :class="{
                      'fa-clock-o': is_database_inited == false,
                      'fa-check': is_database_inited == true,
                      'has-text-success': is_database_inited == true,
                      'fa-spinner fa-spin':
                        init_step == 'database' && !is_database_inited,
                    }"
                  ></i>
                </span>
                <span>{{ $t("initializing database...") }}</span>
              </p>
              <p
                class="mb-1"
                :class="{
                  'has-text-white': is_enterprise_user_inited,
                }"
              >
                <span class="icon">
                  <i
                    class="fa"
                    :class="{
                      'fa-clock-o': is_enterprise_user_inited == false,
                      'fa-check': is_enterprise_user_inited == true,
                      'has-text-success': is_enterprise_user_inited == true,
                      'fa-spinner fa-spin':
                        init_step == 'enterprise_user' &&
                        !is_enterprise_user_inited,
                    }"
                  ></i>
                </span>
                <span>{{ $t("setting up enterprise and admin user...") }}</span>
              </p>
              <p
                :class="{
                  'has-text-white': is_finishing_installation,
                }"
              >
                <span class="icon">
                  <i
                    class="fa"
                    :class="{
                      'fa-clock-o': is_finishing_installation == false,
                      'fa-check': is_finishing_installation == true,
                      'has-text-success': is_finishing_installation == true,
                      'fa-spinner fa-spin':
                        init_step == 'finishing_installation' &&
                        !is_finishing_installation,
                    }"
                  ></i>
                </span>
                <span>{{ $t("finishing installation...") }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="step === 5">
        <h3 class="title is-5 has-text-success has-text-centered">
          {{ $t("setup complete!") }}
        </h3>
        <p class="has-text-centered has-text-white">
          {{ $t("the modul platform has been successfully configured.") }}
        </p>
        <p class="has-text-centered">
          {{ $t("you will be redirected to login page") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { get, error_message, post } from "@/utils";
import currency_catalog from "../../../common/currency.json";
export default {
  name: "InitView",
  data() {
    return {
      step: 1,
      company: {
        name: "modul",
        currency: "GTQ",
        date_format: "DD/MM/YYYY",
        time_format: "HH:mm:ss",
        date_time_format: "DD/MM/YYYY HH:mm",
        default_language: "es",
        authentication_method: "system",
        system_authentication_jwt_key: "str@t0",
        password_recovery_outbox_template_id: ["2"],
        system_authentication_jwt_expire_time_unit: "d",
        system_authentication_jwt_expire_time_quantity: "10",
      },
      admin: {
        username: "lr",
        password: "admin",
        confirmPassword: "admin",
      },
      db: {
        host: "192.168.1.43",
        port: "3306",
        database: "mdl_testing",
        username: "mdl_testing",
        password: "mdl_testing",
        dialect: "mysql",
      },
      system: {
        pythonPath: "/usr/bin/python",
      },
      db_test_result: null,
      python_test_result: null,
      is_initializing: false,
      is_database_inited: false,
      is_enterprise_user_inited: false,
      is_finishing_installation: false,
      is_settings_inited: false,
      init_step: "",
    };
  },
  computed: {
    currencies() {
      return Object.keys(currency_catalog).map((key) => {
        return {
          value: key,
          text: currency_catalog[key].name,
        };
      });
    },
  },
  methods: {
    nextStep() {
      if (this.step === 1 && this.admin.password !== this.admin.confirmPassword)
        return;
      this.step++;
    },
    prevStep() {
      this.step--;
    },
    submitConfig() {
      let v = this;
      v.is_initializing = true; // Start loading state

      v.init_step = "settings_file"; // Set next step
      v.init_settings()
        .then(() => {
          v.init_step = "restart_modul"; // Set next step
          v.restart_modul()
            .then(() => {
              v.init_step = "database"; // Set current step
              v.init_database()
                .then(() => {
                  v.init_step = "enterprise_user"; // Set next step
                  v.init_enterprise_user()
                    .then(() => {
                      console.log("Enterprise user initialized");
                      v.init_step = "finishing_installation"; // Set next step
                      v.finishing_installation()
                        .then(() => {
                          console.log("Initialization complete");
                          v.step = 5; // Go to the final step
                          setTimeout(() => {
                            v.$router.push({
                              path: "/login",
                            }); // Redirect to login page
                          }, 3000); // Wait 2 seconds before redirecting
                          // v.is_initializing = false; // End loading state
                        })
                        .catch((err) => {
                          error_message(err);
                          // v.is_initializing = false; // End loading state
                        });
                    })
                    .catch((err) => {
                      error_message(err);
                      // v.is_initializing = false; // End loading state
                    });
                  // v.is_initializing = false; // End loading state
                  // v.step = 5; // Go to the final step
                })
                .catch((err) => {
                  error_message(err);
                  // v.is_initializing = false; // End loading state
                });
            })
            .catch((err) => {
              error_message(err);
            });
        })
        .catch((err) => {
          error_message(err);
        });
    },
    test_db_connection() {
      let v = this;
      v.db_test_result = null; // Reset previous result
      v.$root.loader(true);
      post("/system/init/test-db", this.db)
        .then(() => {
          v.db_test_result = v.$t("database connection successful");
        })
        .catch((err) => {
          error_message(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    test_python() {
      let v = this;
      v.python_test_result = null; // Reset previous result
      v.$root.loader(true);
      post("/system/init/test-python", { pythonPath: this.system.pythonPath })
        .then((r) => {
          v.python_test_result = r.version;
        })
        .catch((err) => {
          error_message(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    init_database() {
      let v = this;
      return new Promise((resolve, reject) => {
        post("/system/init/database", v.db)
          .then((r) => {
            v.is_database_inited = true; // Mark database as initialized
            resolve(r);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    init_enterprise_user() {
      let v = this;
      return new Promise((resolve, reject) => {
        post("/system/init/enterprise-user", {
          company: v.company,
          admin: v.admin,
          database: v.db,
        })
          .then((r) => {
            v.is_enterprise_user_inited = true; // Mark enterprise user as initialized
            resolve(r);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    finishing_installation() {
      let v = this;
      return new Promise((resolve, reject) => {
        post("/system/init/finish", { company: v.company })
          .then(() => {
            v.restart_modul()
              .then(() => {
                v.is_finishing_installation = true; // Mark system variables as initialized
                resolve();
              })
              .catch((err) => {
                console.error("Error restarting modul:", err);
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    init_settings() {
      let v = this;
      return new Promise((resolve, reject) => {
        post("/system/init/settings", {
          company: v.company,
          admin: v.admin,
          db: v.db,
          system: v.system,
        })
          .then((r) => {
            v.is_settings_inited = true; // Mark settings as initialized
            resolve(r);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    restart_modul() {
      let v = this;
      return new Promise((resolve, reject) => {
        post("/system/init/restart", {})
          .then(() => {
            let connection_succeded = false;
            for (let i = 1; i <= 30; i++) {
              setTimeout(() => {
                if (connection_succeded) return;

                console.log(
                  "trying to get response from server, attempt",
                  i + 1
                );
                get("/system/settings", {})
                  .then(() => {
                    connection_succeded = true;
                    v.is_modul_restarted = true; // Mark modul as restarted
                    resolve();
                  })
                  .catch((error) => {
                    console.log("error", error);
                  });
              }, 1000 * i);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    const v = this;
    v.$root.loader(true);
    get("/system/settings", {})
      .then((r) => {
        if (r && r.run_init_modul_wizard == false) {
          v.$router.push({
            path: "/login",
          });
        }
      })
      .catch((err) => {
        error_message(err);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style scoped>
.ctrn {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
}
</style>

<!-- No custom styles, Bulma is used -->
